import React, { createContext, useContext, useEffect } from "react";
import { useRouter } from "next/router";
import { useUser } from "utils/auth/useUser";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const { isAuthenticated, loading, user, logout, setUser } = useUser();

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, loading, logout, setUser }}>{children}</AuthContext.Provider>
  );
};

export default function useAuth() {
  const context = useContext(AuthContext);

  return context;
}

export function ProtectRoute(Component) {
  return () => {
    const { user, isAuthenticated, loading } = useAuth();
    const router = useRouter();

    useEffect(() => {
      if (!isAuthenticated && !loading) router.push("/connexion");
    }, [loading, isAuthenticated]);

    return <Component {...arguments} />;
  };
}
